// @ts-nocheck
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { AlertCircle, LogIn } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useLanguage } from '@/components/ui/LanguageContext';

export default function RegistrationRequired() {
  const navigate = useNavigate();
  const { language } = useLanguage();

  const handleBackToHome = () => {
    navigate('/');
  };

  const handleGoToLogin = () => {
    navigate('/Login');
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-[#faf6f1] via-[#f5ede3] to-[#efe5d8] text-[#2d1810] flex items-center justify-center px-4">
      {/* Decorative elements */}
      <div className="fixed inset-0 pointer-events-none opacity-30">
        <div className="absolute top-10 left-10 w-32 h-32 border-2 border-[#8b6f47] rounded-full opacity-20" />
        <div className="absolute top-40 right-20 w-20 h-20 border-2 border-[#8b6f47] rounded-full opacity-20" />
        <div className="absolute bottom-20 left-1/4 w-24 h-24 border-2 border-[#8b6f47] rounded-full opacity-20" />
      </div>

      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="relative z-10 max-w-md w-full"
      >
        <div className="bg-white/90 backdrop-blur-md border-2 border-[#d4c4b0] rounded-2xl shadow-xl overflow-hidden">
          {/* Header with icon */}
          <div className="bg-gradient-to-r from-[#f5ede3] to-[#efe5d8] p-8 text-center border-b-2 border-[#d4c4b0]">
            <motion.div
              initial={{ scale: 0 }}
              animate={{ scale: 1 }}
              transition={{ delay: 0.2, type: 'spring' }}
              className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-white border-2 border-[#8b6f47] mb-4"
            >
              <AlertCircle className="w-10 h-10 text-[#d97706]" />
            </motion.div>
            <h1 className="text-3xl font-bold text-[#3d2817] mb-2" style={{ fontFamily: 'serif' }}>
              {language === 'ja' ? '登録が必要です' : 'Registration Required'}
            </h1>
          </div>

          {/* Content */}
          <div className="p-8">
            <div className="mb-8">
              <p className="text-lg text-[#5d4529] mb-4 text-center font-medium">
                {language === 'ja'
                  ? '登録をしてログインしてください'
                  : 'Please register and log in'}
              </p>
              <p className="text-[#7a6a56] text-center mb-6">
                {language === 'ja'
                  ? 'このページにアクセスするには、イラストアカデミアに登録してログインする必要があります。'
                  : 'To access this page, you need to register and log in to Illust Academia.'}
              </p>
            </div>

            {/* Info box */}
            <div className="bg-[#fef3c7] border-l-4 border-[#d97706] p-4 rounded-lg mb-8">
              <p className="text-sm text-[#92400e]">
                {language === 'ja'
                  ? 'Discordアカウントでシームレスに登録・ログインできます。'
                  : 'You can easily register and log in with your Discord account.'}
              </p>
            </div>

            {/* Buttons */}
            <div className="space-y-3">
              <Button
                onClick={handleGoToLogin}
                className="w-full justify-center items-center gap-2 bg-[#3d2817] hover:bg-[#2d1810] text-[#f5ede3] border-2 border-[#8b6f47] shadow-md py-6 text-base font-medium transition-all"
              >
                <LogIn className="w-5 h-5" />
                {language === 'ja' ? 'ログインページへ' : 'Go to Login'}
              </Button>

              <Button
                onClick={handleBackToHome}
                className="w-full justify-center bg-white hover:bg-[#f5ede3] text-[#3d2817] border-2 border-[#8b6f47] shadow-md py-6 text-base font-medium transition-all"
              >
                {language === 'ja' ? 'トップページに戻る' : 'Back to Home'}
              </Button>
            </div>
          </div>
        </div>

        {/* Footer text */}
        <p className="text-center text-[#7a6a56] text-xs mt-6">
          {language === 'ja'
            ? 'サポートが必要な場合はヘルプページをご確認ください。'
            : 'For support, please check the Help page.'}
        </p>
      </motion.div>
    </div>
  );
}
